import { useEffect, useState } from "react";

export default function usePropertySort(items = [], sort) {
  const [sortedResults, setSortedResults] = useState([]);

  useEffect(() => {
    if (!sort || sort === "Sort by") {
      setSortedResults([...items]);
      return;
    }

    const sorted = [...items].sort((a, b) => {
      switch (sort) {
        case "Price (High to Low)":
          return (b.price_raw || 0) - (a.price_raw || 0);

        case "Price (Low to High)":
          return (a.price_raw || 0) - (b.price_raw || 0);

        case "Newest":
          return new Date(b.created_at) - new Date(a.created_at);

        case "Bedrooms":
          return (b.details?.bedrooms || 0) - (a.details?.bedrooms || 0);

        case "Bathrooms":
          return (b.details?.bathrooms || 0) - (a.details?.bathrooms || 0);

        case "Square Feet":
          return (b.details?.size_sqft || 0) - (a.details?.size_sqft || 0);

        default:
          return 0;
      }
    });

    setSortedResults(sorted);
  }, [items, sort]);

  return sortedResults;
}
